import React, { useEffect, useMemo, useState } from 'react'
import styles from "./Managestyles.module.css"
import dashboardmodal from "./ProjectModal.module.css"
import { epl } from '../../clientstyles/epl'
import { edp } from '../../clientstyles/edp'
import csiro from '../../clientstyles/Book/csiro'


const clients = {
    Book: [
        {
            client: "CSIRO",
        }
    ],
    Journal: [
        {
            client: "EPL",
        },
        {
            client: "EDP",
        }
    ]
}





const ManageStyles = ({ setSettingsModal }) => {
    const [TemplateactiveTab, TemplateSetActiveTab] = useState("Book")
    const [selectedClientKey, setSelectedClientKey] = useState("");
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedClientStyles, setSelectedClientStyles] = useState([]);


    useEffect(() => {
        if (!selectedClientKey) return;

        const CLIENT_KEY_MAP = {
            CSIRO: "csiro",
            EDP: "edp",
            EPL: "epl",
        };

        const clientKey = CLIENT_KEY_MAP[selectedClientKey];
        if (!clientKey) return;

        try {
            const stored = localStorage.getItem("generalStyles");
            const arr = stored ? JSON.parse(stored) : [];

            const entry = Array.isArray(arr)
                ? arr.find(item => item.client === clientKey)
                : null;

            setSelectedClientStyles(entry?.styles || []);
        } catch {
            setSelectedClientStyles([]);
        }
    }, [selectedClientKey]);
    // useEffect(()=>{
    //     const data=localstorage.getItem
    // },[])

    const handleChange = (e) => {
        let selected = e.target.value;
        setSelectedClientKey(selected);
    }

    const clientMap = useMemo(() => ({
        epl,
        edp,
        csiro
    }), []);

    useEffect(() => {
        setSelectedClient(clientMap[selectedClientKey?.toLowerCase()] || null);
    }, [selectedClientKey, clientMap]);

    useEffect(() => {
        setSelectedClient("")
    }, [TemplateactiveTab])

    const handleCheckChange = (key) => {
        setSelectedClientStyles(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    };


    const handleStore = () => {
        if (!selectedClientKey || selectedClientStyles.length === 0) return;

        const CLIENT_KEY_MAP = {
            CSIRO: "csiro",
            EDP: "edp",
            EPL: "epl",
        };

        const clientKey = CLIENT_KEY_MAP[selectedClientKey];
        if (!clientKey) return;

        const newEntry = {
            client: clientKey,
            styles: selectedClientStyles,
        };

        // Read existing array
        const stored = localStorage.getItem("generalStyles");
        let generalArray = [];

        try {
            generalArray = stored ? JSON.parse(stored) : [];
            if (!Array.isArray(generalArray)) generalArray = [];
        } catch {
            generalArray = [];
        }

        // Replace or insert
        const index = generalArray.findIndex(
            item => item.client === clientKey
        );

        if (index !== -1) {
            generalArray[index] = newEntry;
        } else {
            generalArray.push(newEntry);
        }

        // Save back
        localStorage.setItem("generalStyles", JSON.stringify(generalArray));

        alert("Stored successfully");
        setSettingsModal(false);
    };


    return (
        <div className={dashboardmodal.modalContentContainer}>
            <div className={`${dashboardmodal.projectButtongrouping}`}>
                <button
                    className={TemplateactiveTab === "Book" ? dashboardmodal.activeTab : dashboardmodal.tab}
                    onClick={() => TemplateSetActiveTab("Book")}
                    style={{ color: "#222" }}
                >
                    BOOK
                </button>
                <button
                    className={TemplateactiveTab === "Journal" ? dashboardmodal.activeTab : dashboardmodal.tab}
                    onClick={() => TemplateSetActiveTab("Journal")}
                    style={{ color: "#222" }}
                >
                    <p>JOURNAL</p>
                </button>
            </div>
            <div className={styles.clientContainer}>
                <div className={styles.clientBoxContainer}>
                    <h1 style={{ color: "#222" }}>Choose Client :</h1>
                    {clients[TemplateactiveTab].map((client, index) => (
                        <div className={styles.clientInputBox} key={index} style={{ color: "#222" }}>
                            <input
                                type="radio"
                                name={TemplateactiveTab}
                                value={client.client}
                                className={styles.clientBox}
                                onChange={handleChange}
                                checked={selectedClientKey === client.client}
                            />
                            <label>{client.client}</label>
                        </div>
                    ))}
                </div>
                <div className={styles.stylePreviewContainer}>
                    <h1 style={{ color: "#222" }}>Select Styles :</h1>
                    <div className={styles.stylePreviewBox}>
                        {selectedClient && selectedClient !== "" ?
                            Object.entries(selectedClient)?.map(([keyName, value]) => (
                                <div key={keyName} className={styles.individualstyle}>
                                    <input
                                        type="checkbox"
                                        checked={selectedClientStyles.includes(keyName)}
                                        onChange={() => handleCheckChange(keyName)}
                                    />

                                    <label>
                                        {keyName}
                                    </label>
                                </div>
                            )) : <p>Select a Client to display styles.</p>
                        }
                    </div>
                </div>
                <div className={styles.nextbtn}>
                    <button className={styles.nextbutton} onClick={() => handleStore()} >Next</button>
                </div>
            </div>
        </div >
    )
}

export default ManageStyles